import { takeLatest, takeLeading, call, put } from "redux-saga/effects";
import { request, showNotification } from "@thewebops/admin-panel";
import actions from "./actions";

function* lockCoach(action) {
  const { item } = action.payload;
  const { success, failure } = actions.lockCoach;
  try {
    yield call(request, {
      url: `admin/coaches/${item.id}/lock`,
      method: "patch",
      authenticated: true,
    });

    yield put(success(item));
  } catch (error) {
    // The API refuses to deactivate a main coach.
    const message = error.response && error.response.status === 422 ? "Main coaches can't be deactivated." : undefined;
    showNotification("Coach", "error", message);
    yield put(failure());
  }
}

function* unlockCoach(action) {
  const { item } = action.payload;
  const { success, failure } = actions.unlockCoach;
  try {
    yield call(request, {
      url: `admin/coaches/${item.id}/unlock`,
      method: "patch",
      authenticated: true,
    });

    yield put(success(item));
  } catch (error) {
    yield put(failure());
  }
}

function* getCoach(id) {
  const { data } = yield call(request, { url: `admin/coaches/${id}`, method: "get", authenticated: true });
  return data.coach || data;
}

function* updateCoachUsers(id, coachUsersAttributes) {
  const { data } = yield call(request, {
    url: `admin/coaches/${id}`,
    method: "put",
    authenticated: true,
    data: { coach: { coach_users_attributes: coachUsersAttributes } },
  });
  return data.coach || data;
}

// Adds the members to the new coach first, which moves their conversations (CoachInteractors::UpdateConversation),
// then removes them from the deactivated coach.
function* moveCoachMembers(action) {
  const { item, target } = action.payload;
  const { success, failure } = actions.moveCoachMembers;
  let addedToTarget = false;
  try {
    const source = yield call(getCoach, item.id);
    const targetCoach = yield call(getCoach, target.id);
    const targetUserIds = targetCoach.coach_users.map((coachUser) => coachUser.user_id);
    const newUsers = source.coach_users.filter((coachUser) => !targetUserIds.includes(coachUser.user_id));

    const updatedTarget = newUsers.length
      ? yield call(
          updateCoachUsers,
          target.id,
          newUsers.map((coachUser) => ({ user_id: coachUser.user_id })),
        )
      : targetCoach;
    addedToTarget = true;
    const updatedSource = yield call(
      updateCoachUsers,
      item.id,
      source.coach_users.map((coachUser) => ({ id: coachUser.id, _destroy: true })),
    );

    const count = source.coach_users.length;
    showNotification(
      "Coach",
      "success",
      `Moved ${count} ${count === 1 ? "member" : "members"} to ${target.name || target.email}.`,
    );
    yield put(success([updatedSource, updatedTarget]));
  } catch (error) {
    // Once the members are on the new coach, a retry only removes them from the deactivated one.
    const message = addedToTarget
      ? "The members were added to the new coach but are still listed on the deactivated coach. Reload and try again."
      : "The members couldn't be moved. Please try again.";
    showNotification("Coach", "error", message);
    yield put(failure());
  }
}

function* watchEntitylockCoach() {
  const { request } = actions.lockCoach;
  yield takeLatest(request, lockCoach);
}

function* watchEntityUnlockCoach() {
  const { request } = actions.unlockCoach;
  yield takeLatest(request, unlockCoach);
}

function* watchEntityMoveCoachMembers() {
  const { request } = actions.moveCoachMembers;
  // takeLeading: a second move must not cancel one halfway through its two requests.
  yield takeLeading(request, moveCoachMembers);
}

export default [watchEntitylockCoach, watchEntityUnlockCoach, watchEntityMoveCoachMembers];
